module.exports = __webpack_public_path__ + "media/images/icons/SVG/001-a5fa8b27c0f5e5512c78a21f43e85836.svg";